import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { values } from 'lodash'

// Components
import Loader from 'app/views/components/Loader'
import OrganizationLayout from 'app/views/containers/Organizations/components/Layout'

// Redux
import { getTeamsReportUsers } from 'app/state/modules/hacker'
import { getTeams } from 'app/state/modules/team'

// Utils
import analytics from 'app/views/utils/analytics'

class MiniLessonReport extends React.Component {
  constructor(props) {
    super(props)

    const lastMonth = new Date()
    lastMonth.setMonth(lastMonth.getMonth() - 1)

    this.state = {
      displayResults: false,
      selectedCompleted: 'true',
      selectedLessons: new Set(),
      selectedTeam: '',
    }

    this.handleChangeSelect = this.handleChangeSelect.bind(this)
    this.handleChangeTeam = this.handleChangeTeam.bind(this)
    this.handleClickCheckbox = this.handleClickCheckbox.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleClickGo = this.handleClickGo.bind(this)
  }

  componentDidMount() {
    this.props.getTeams(this.props.match.params.organization_uuid)

    analytics.page('page-organizations-report-mini-lessons')
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.organization_uuid !== this.props.match.params.organization_uuid) {
      this.props.getTeams(nextProps.match.params.organization_uuid)
    }
  }

  handleChangeSelect(e) {
    this.setState({
      displayResults: false,
      selectedCompleted: e.target.value,
    })
  }

  handleChangeTeam(e) {
    this.setState({
      displayResults: false,
      selectedTeam: e.target.value,
    })
  }

  handleClickCheckbox(e) {
    const { selectedLessons } = this.state
    if (selectedLessons.has(e.target.value)) {
      selectedLessons.delete(e.target.value)
    } else {
      selectedLessons.add(e.target.value)
    }
    this.setState({
      displayResults: false,
      selectedLessons,
    })
  }

  handleClickEdit(e) {
    e.preventDefault()
    this.setState({ displayResults: false })
  }

  handleClickGo(e) {
    e.preventDefault()
    let completed = false
    if (this.state.selectedCompleted === 'true') {
      completed = true
    }
    this.props.getTeamsReportUsers(
      this.props.match.params.organization_uuid,
      this.state.selectedLessons,
      this.state.selectedTeam,
      completed,
    )
    this.setState({
      displayResults: true,
    })
  }

  render() {
    const currentTeamId = this.props.match.params.organization_uuid

    return (
      <OrganizationLayout {...this.props} active="reports">
        <h2>Generate a report</h2>
        <div className="uk-card uk-card-default uk-card-body">
          <div className="uk-container-small">
            <form className="uk-grid-small" data-uk-grid>
              <div
                className="uk-width-1-1@s"
                style={{ display: this.state.displayResults ? 'block' : 'none' }}
              >
                <button
                  type="button"
                  className="uk-button uk-button-primary tm-button-default"
                  onClick={this.handleClickEdit}
                >
                  Edit Report
                </button>
              </div>

              <div style={{ display: this.state.displayResults ? 'none' : 'block' }}>
                <div className="uk-width-1-1@s">
                  <div className="uk-margin">
                    Find users from:
                    <select
                      className="uk-select"
                      value={this.state.selectedTeam}
                      data-test-id="input-select-team"
                      onChange={this.handleChangeTeam}
                    >
                      <option value="">All Teams</option>
                      {this.props.teams.map((team) => (
                        <option key={team.uuid} value={team.uuid}>
                          {team.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="uk-margin">
                    who have:
                    <select
                      data-test-id="input-select-completed"
                      className="uk-select"
                      value={this.state.selectedCompleted}
                      onChange={this.handleChangeSelect}
                    >
                      <option value="true">Completed</option>
                      <option value="false">Not Completed</option>
                    </select>
                  </div>
                  <p>all of the following:</p>
                </div>
                <div className="uk-width-1-1@s uk-margin-left">
                  <strong>Secure Development Training</strong>
                  <div className="uk-padding-small">
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      name="lessons"
                      value="9ac32a8b-98a0-4b59-84dd-abda4a388187"
                      onClick={this.handleClickCheckbox}
                      style={{ marginRight: 10 }}
                    />
                    SQL Injection Mini Lesson
                    <br />
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      name="lessons"
                      value="f209214a-b730-47d3-896f-5d442feba9a6"
                      onClick={this.handleClickCheckbox}
                      style={{ marginRight: 10 }}
                    />
                    Broken Authentication Mini Lesson
                    <br />
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      name="lessons"
                      value="d23c6ca6-0124-41b6-a029-67502a358bc4"
                      onClick={this.handleClickCheckbox}
                      style={{ marginRight: 10 }}
                    />
                    Sensitive Data Exposure Mini Lesson
                    <br />
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      name="lessons"
                      value="a6c0866c-95e9-4a01-b3c2-9a9feff075c7"
                      onClick={this.handleClickCheckbox}
                      style={{ marginRight: 10 }}
                    />
                    XML External Entities Mini Lesson
                    <br />
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      name="lessons"
                      value="bf9c431c-9909-4caa-bd56-dcc35474747f"
                      onClick={this.handleClickCheckbox}
                      style={{ marginRight: 10 }}
                    />
                    Broken Access Control Mini Lesson
                    <br />
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      name="lessons"
                      value="1b8041b9-8895-463b-9442-84dc043bc7f9"
                      onClick={this.handleClickCheckbox}
                      style={{ marginRight: 10 }}
                    />
                    Security Misconfiguration Mini Lesson
                    <br />
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      name="lessons"
                      value="ea9406a7-3e09-4255-ad79-a3954e17c67a"
                      onClick={this.handleClickCheckbox}
                      style={{ marginRight: 10 }}
                    />
                    Cross-Site Scripting Mini Lesson
                    <br />
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      name="lessons"
                      value="87694751-8b35-4f6c-b514-6d463a357e3f"
                      onClick={this.handleClickCheckbox}
                      style={{ marginRight: 10 }}
                    />
                    Insecure Deserialization Mini Lesson
                    <br />
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      name="lessons"
                      value="5a3fd3a6-5388-424b-983d-65219eae8b7d"
                      onClick={this.handleClickCheckbox}
                      style={{ marginRight: 10 }}
                    />
                    Using Components with Known Vulnerabilities Mini Lesson
                    <br />
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      name="lessons"
                      value="5f7d4551-5e55-41eb-b367-7d6bbcbbd46a"
                      onClick={this.handleClickCheckbox}
                      style={{ marginRight: 10 }}
                    />
                    Insufficient Logging & Monitoring Mini Lesson
                    <br />
                  </div>
                </div>
                <div className="uk-width-1-1@s">
                  <br />
                  <button
                    type="button"
                    className="uk-button uk-button-primary tm-button-default"
                    onClick={this.handleClickGo}
                  >
                    Run Report
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        {this.state.displayResults && (
          <div className="uk-padding uk-padding-remove-horizontal">
            {this.props.loadingReportUsers === true ? (
              <Loader visible />
            ) : (
              <div>
                {this.props.errorReportUsers ? (
                  <p className="uk-text-danger">There was an error with your report</p>
                ) : (
                  <div>
                    {this.props.reportUsers.length === 0 ? (
                      <p>No results were found for this report.</p>
                    ) : (
                      <div>
                        <p>The following users match the report above.</p>
                        <table className="uk-table uk-table-divider uk-table-responsive">
                          <thead>
                            <tr>
                              <th>Email</th>
                              <th>Role</th>
                              <th>License</th>
                              <th />
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.reportUsers.map((user) => {
                              let role = 'Member'
                              if (user.role === 'admin') {
                                role = 'Admin'
                              }
                              return (
                                <tr key={user.uuid}>
                                  <td>
                                    <Link
                                      to={`/admin/${currentTeamId}/users/${user.uuid}`}
                                      className="uk-text-primary"
                                    >
                                      {user.email}
                                    </Link>
                                  </td>
                                  <td>
                                    <span
                                      className="uk-label uk-label-secondary"
                                      style={{
                                        marginTop: 8,
                                      }}
                                    >
                                      {role}
                                    </span>
                                  </td>
                                  <td>
                                    {user.has_license === true ? (
                                      <div
                                        className="uk-icon-button uk-label-success"
                                        data-uk-icon="check"
                                      />
                                    ) : (
                                      <div className="uk-icon-button" data-uk-icon="close" />
                                    )}
                                  </td>
                                  <td className="uk-text-right">
                                    <Link
                                      className="uk-button uk-button-primary tm-button-default"
                                      to={`/admin/${currentTeamId}/users/${user.uuid}`}
                                      style={{
                                        height: 30,
                                        textTransform: 'none',
                                        lineHeight: '30px',
                                      }}
                                    >
                                      See Details
                                    </Link>
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = state => ({
  // content
  courses: state.content.courses,
  lessonMap: state.content.lessonMap,
  tests: state.content.tests,

  // hacker
  organizations: values(state.hacker.organizationsList),
  reportUsers: state.hacker.reportUsers,
  errorReportUsers: state.hacker.errorReportUsers,
  mustPassCodingExercise: state.hacker.mustPassCodingExercise,
  loadingReportUsers: state.hacker.loadingReportUsers,

  // team
  teams: state.team.teams,
  hasLoadedTeams: state.team.hasLoadedTeams,

  // user
  email: state.auth.user.email,
})
const mapDispatchToProps = dispatch => ({
  getTeams: organzationId => dispatch(getTeams(organzationId)),
  getTeamsReportUsers: (organizationId, contentIds, teamId, completed) => dispatch(getTeamsReportUsers(organizationId, contentIds, teamId, completed)),
})
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(MiniLessonReport),
)
